import bootstrapNotify from '../../../../../../modules/Gull/Framework/bootstrapNotify.js';
import validation from '../../../../../../modules/Gull/Framework/validation.js';

/**
 * Offerte Aanvragen - Stap 4
 */
const stap4 = {
	/**
	 * Initialiseert stap 4 functies
	 */
	init() {
		// Init events
		stap4.initEvents();

		// Hernummer voor elk product de dekkingsvarianten
		document.querySelectorAll('.dekkingen[data-product]').forEach(function (element) {
			const product = element.getAttribute('data-product');
			stap4.dekking.hernummeren(product);
		});
	},

	/**
	 * Initialiseert event listeners voor stap 4
	 */
	initEvents() {
		// Bind dekkingToevoegen aan button
		document.body.addEventListener('click', function (e) {
			const targetButton = e.target.closest('[data-button-dekking-toevoegen]');
			if (targetButton) {
				stap4.dekking.toevoegen(targetButton);
			}
		});

		// P-400 Collectieve ongevallen
		document.addEventListener('change', (e) => {
			if (e.target.matches('.P400-uitoverlijd')) {
				stap4.product.updateInvaliditeitsuitkering(e.target);
			}
		});

		// Voeg click event toe (delegated) voor dekking-verwijderen buttons
		document.body.addEventListener('click', function (e) {
			const targetButton = e.target.closest('[data-button-dekking-verwijderen]');
			if (targetButton) {
				stap4.dekking.verwijderen(targetButton);
			}
		});
	},

	/**
	 * Functionaliteit voor het toevoegen en verwijderen van dekkingsvarianten
	 */
	dekking: {
		/**
		 * Verwijdert een dekkingsvariant
		 *
		 * @param {HTMLElement} el - Het element dat de verwijdering heeft geactiveerd
		 *
		 * @returns {void}
		 */
		verwijderen: function (el) {
			const product = el.closest('.dekkingen').getAttribute('data-product');
			const dekkingen = document.querySelectorAll('.dekkingen[data-product="' + product + '"] .dekking');

			if (dekkingen.length > 1) {
				el.closest('.dekking').remove();
				stap4.dekking.hernummeren(product);
			} else {
				bootstrapNotify('danger', 'LET OP!', 'Je moet minimaal 1 dekking behouden.');
			}
		},

		/**
		 * Hernummert bestaande dekkingsvarianten en werkt hun formulierveldnamen bij
		 *
		 * @param {string} product - De product identificatie
		 *
		 * @returns {void}
		 */
		hernummeren: function (product) {
			const dekkingen = document.querySelectorAll('.dekkingen[data-product="' + product + '"] .dekking');

			dekkingen.forEach((dekking, indexd) => {
				const dekkingNummers = dekking.querySelectorAll('span.dekking-nummer');
				const lastDekkingNummer = dekkingNummers[dekkingNummers.length - 1];
				if (lastDekkingNummer) {
					lastDekkingNummer.textContent = indexd + 1;
				}

				dekking.querySelectorAll('select, input').forEach((element) => {
					const nameA = element.getAttribute('name').split('][');
					const name = nameA.slice(-1)[0].slice(0, -1);
					element.setAttribute('name', product + '[dekkingArray][' + indexd + '][' + name + ']');
				});
			});

			const removeButtons = document.querySelectorAll('.dekkingen[data-product="' + product + '"] .dekking [data-button-dekking-verwijderen]');
			removeButtons.forEach((button) => {
				if (dekkingen.length > 1) {
					button.classList.remove('invisible');
				} else {
					button.classList.add('invisible');
				}
			});
		},

		/**
		 * Voegt een nieuwe dekkingsvariant toe door de laatste te klonen
		 *
		 * @param {HTMLElement} el - Het element dat de toevoeging heeft geactiveerd
		 *
		 * @returns {void}
		 */
		toevoegen: function (el) {
			const product = el.getAttribute('data-product');
			const dekkingContainer = document.querySelector('.dekkingen[data-product="' + product + '"]');
			const maxDekkingen = parseInt(dekkingContainer.getAttribute('data-max-dekkingen'));
			const existingDekkingen = dekkingContainer.querySelectorAll('.dekking');

			if (existingDekkingen.length < maxDekkingen) {
				const lastDekking = existingDekkingen[existingDekkingen.length - 1];
				const newDekking = lastDekking.cloneNode(true);

				newDekking.style.display = 'none';
				dekkingContainer.appendChild(newDekking);

				setTimeout(() => {
					newDekking.style.display = '';
				}, 0);

				const validateElements = newDekking.querySelectorAll('input[data-validate], select[data-validate]');
				validateElements.forEach((element) => {
					element.removeEventListener('blur', validation.checkInputBlur);
					element.addEventListener('blur', validation.checkInputBlur);
				});

				stap4.dekking.hernummeren(product);
			} else {
				const aantal = maxDekkingen === 1 ? '1 dekking' : maxDekkingen + ' dekkingen';
				let bericht = 'je kan maximaal ' + aantal;

				const productElement = document.querySelector('.product-vragen[data-product="' + product + '"] h4');
				const product_txt = productElement ? productElement.innerHTML : '';

				if (product_txt) {
					bericht = bericht + ' voor ' + product_txt;
				}
				bericht = bericht + ' selecteren.';

				bootstrapNotify('warning', 'Helaas', bericht);
			}
		},
	},

	/**
	 * Product functionaliteiten
	 */
	product: {
		/**
		 * Updates the invaliditeitsuitkering to be twice the overlijdensuitkering
		 *
		 * @param {HTMLElement} element - Het input element van de overlijdensuitkering
		 *
		 * @returns {void}
		 */
		updateInvaliditeitsuitkering(element) {
			element.closest('.dekking').querySelector('.P400-uitinvalide').value = element.value * 2;
		},
	},
};

export default stap4;
